"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const components_common_tooltip_1 = require("@hotelplan/components.common.tooltip");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const FeatureGroupName = styled_components_1.default.div(({ theme: { space } }) => ({
    marginBottom: space[2],
}));
const EnabledFeature = styled_components_1.default.div({
    '.feature-name': {
        fontWeight: 'normal',
    },
});
const FeatureIconWrapper = styled_components_1.default.span((0, util_theme_sxc_1.sx2CssThemeFn)({
    mr: 2,
    verticalAlign: [`sub`, `middle`],
}), ({ theme: { colors } }) => ({
    '.feature-icon': {
        paddingTop: '1px',
        color: colors.success,
    },
}), ({ theme }) => {
    var _a;
    return (Object.assign({}, (((_a = theme.customTooltip) === null || _a === void 0 ? void 0 : _a.FeatureIconWrapper) || {})));
});
const TooltipWrapper = (0, styled_components_1.default)(components_common_tooltip_1.Tooltip).attrs({
    testId: 'features-group-id',
})(({ maxTooltipHeightPx, theme }) => {
    var _a;
    return (Object.assign({ overflow: 'auto', maxHeight: `${maxTooltipHeightPx}px` }, (((_a = theme.customTooltip) === null || _a === void 0 ? void 0 : _a.wrapper) || {})));
});
const FeatureGroupTooltip = ({ features, featureGroupName, maxTooltipHeightPx, successIcon }) => {
    const enabledFeatures = features.filter(f => f.enabled);
    if (!enabledFeatures.length)
        return null;
    return (react_1.default.createElement(TooltipWrapper, { withAutoPositioning: true, maxTooltipHeightPx: maxTooltipHeightPx },
        react_1.default.createElement(FeatureGroupName, { className: "feature-group-name" }, featureGroupName),
        enabledFeatures.map((feature, i) => {
            return (react_1.default.createElement(EnabledFeature, { key: i, className: "feature-description" },
                react_1.default.createElement(FeatureIconWrapper, null,
                    react_1.default.createElement(components_common_icon_1.Icon, { className: "feature-icon", name: successIcon ? successIcon : 'success' })),
                react_1.default.createElement("span", { className: "feature-name" }, feature.name)));
        })));
};
exports.default = FeatureGroupTooltip;
//# sourceMappingURL=FeatureGroupTooltip.js.map